const COUNTRY_CURRENCY = {
  angola: "AOA",
  botswana: "BWP",
  "dr congo": "CDF",
  "democratic republic of congo": "CDF",
  eswatini: "SZL",
  lesotho: "LSL",
  malawi: "MWK",
  mozambique: "MZN",
  namibia: "NAD",
  "south africa": "ZAR",
  zambia: "ZMW",
  zimbabwe: "USD",
};

function cleanText(value = "") {
  return String(value || "").trim();
}

export function normalizePharmacyCurrency(value = "", fallbackCurrency = "") {
  const normalized = cleanText(value).toUpperCase();
  if (normalized) return normalized;
  return cleanText(fallbackCurrency).toUpperCase();
}

export function resolveCountryCurrencyForPharmacy(country = "", fallbackCurrency = "") {
  const normalized = cleanText(country).toLowerCase();
  return COUNTRY_CURRENCY[normalized] || normalizePharmacyCurrency("", fallbackCurrency);
}

export function resolveBranchCurrency({
  explicitCurrency = "",
  profile = null,
  meta = null,
  fallbackCurrency = "ZAR",
  onFallback = null,
} = {}) {
  const safeProfile = profile && typeof profile === "object" ? profile : {};
  const safeMeta = meta && typeof meta === "object" ? meta : {};

  const direct = normalizePharmacyCurrency(
    explicitCurrency ||
      safeProfile.currency ||
      safeProfile.connect_meta?.currency ||
      safeProfile.connectMeta?.currency ||
      safeMeta.pharmacy_currency ||
      safeMeta.pharmacyCurrency ||
      safeMeta.branch_currency ||
      safeMeta.branchCurrency,
    "",
  );
  if (direct) return direct;

  const countryCurrency = resolveCountryCurrencyForPharmacy(
    safeMeta.pharmacy_country ||
      safeMeta.pharmacyCountry ||
      safeProfile.country ||
      safeMeta.country,
    "",
  );
  if (countryCurrency) return countryCurrency;

  const fallback = normalizePharmacyCurrency("", fallbackCurrency || "ZAR") || "ZAR";
  if (typeof onFallback === "function") {
    onFallback({
      reason: "missing_branch_currency",
      fallbackCurrency: fallback,
    });
  }
  return fallback;
}

export function centsToPriceAmount(value = 0) {
  const cents = Number(value);
  if (!Number.isFinite(cents) || cents <= 0) return 0;
  return Math.round(cents) / 100;
}

export function normalizeInventoryPrice(row = {}, branchCurrency = "ZAR") {
  const explicitAmount = row.unitPrice ?? row.unit_price ?? row.retail_price ?? row.price;
  const parsedAmount = Number(String(explicitAmount ?? "").replace(/[^\d.-]/g, "").trim());
  const centsAmount = centsToPriceAmount(row.unit_price_cents);
  const amount = Number.isFinite(parsedAmount) && parsedAmount > 0 ? parsedAmount : centsAmount;
  const currency = resolveBranchCurrency({
    explicitCurrency: row.currency,
    fallbackCurrency: branchCurrency,
  });

  return {
    amount,
    currency,
    label: amount > 0 ? amount.toFixed(2) : "",
  };
}

export function buildPharmacyPricePayload({
  amount,
  explicitCurrency = "",
  profile = null,
  meta = null,
  fallbackCurrency = "ZAR",
} = {}) {
  const parsedAmount = Number(String(amount ?? "").replace(/[^\d.]/g, "").trim());
  if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
    throw new Error("price must be a positive number.");
  }

  return {
    amount: Math.round(parsedAmount * 100) / 100,
    currency: resolveBranchCurrency({
      explicitCurrency,
      profile,
      meta,
      fallbackCurrency,
    }),
  };
}
